import React from 'react'

export const QuizHeader = () => {
  return (
    <div className="mb-5">
      <h1 className="me-course-title">Flashcards</h1>
      <h2 className="me-page-title">Quiz Me</h2>
    </div>
  )
}
